module.exports = __webpack_public_path__ + "static/product3_1-e6bd98013c307985de7813f1caf5aee7.jpg";